// ABOUTME: The weekday and month names the date pickers show, in the current UI language.
// ABOUTME: Memoised on the language, so a re-render does not rebuild them.

import { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { getDateLocale, getMonthLabels, getWeekdayLabels } from "@/model/dateLocales"

export const useCalendarLabels = () => {
  const { i18n } = useTranslation()
  return useMemo(() => {
    const dateLocale = getDateLocale(i18n.language)
    return { weekdays: getWeekdayLabels(dateLocale), monthLabels: getMonthLabels(dateLocale) }
  }, [i18n.language])
}
